
export const API_LOCALSTORAGE_KEY = 'wiapitoken';

export const getStoredApiToken = () => window.localStorage.getItem(API_LOCALSTORAGE_KEY) || undefined;

export const setStoredApiToken = (token: string) => window.localStorage.setItem(
    API_LOCALSTORAGE_KEY,
    token
);
